export function FormatTimeDifference(updatedOn) {
  const currentTimestamp = Math.floor(new Date().getTime() / 1000);
  const dateObject = new Date(updatedOn);
  const unixTimestamp = Math.floor(dateObject.getTime() / 1000);
  const timeDifferenceInSeconds = currentTimestamp - unixTimestamp;

  if (timeDifferenceInSeconds < 60 && timeDifferenceInSeconds >= 0) {
    return `${timeDifferenceInSeconds} ${timeDifferenceInSeconds !== 1 ? 'seconds' : 'second'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 3600) {
    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    return `${minutes} ${minutes !== 1 ? 'minutes' : 'minute'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 86400) {
    const hours = Math.floor(timeDifferenceInSeconds / 3600);
    return `${hours} ${hours !== 1 ? 'hours' : 'hour'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 604800) {
    const days = Math.floor(timeDifferenceInSeconds / 86400);
    return `${days} ${days !== 1 ? 'days' : 'day'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 2628000) {
    const weeks = Math.floor(timeDifferenceInSeconds / 604800);
    return `${weeks} ${weeks !== 1 ? 'weeks' : 'week'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 31536000) {
    const months = Math.floor(timeDifferenceInSeconds / 2628000);
    return `${months} ${months !== 1 ? 'months' : 'month'} ${'ago'}`;
  } else {
    const years = Math.floor(timeDifferenceInSeconds / 31536000);
    return `${years} ${years !== 1 ? 'years' : 'year'} ${'ago'}`;
  }
}

// Robustly parse a backend timestamp that may or may not carry tz info.
// Returns a Date, or null when the value is missing/unparseable.
export function parseUtcDate(value) {
  if (!value) return null;
  const hasTz = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);
  const d = new Date(hasTz ? value : `${value}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatTimeDifferenceUTC(utcTimeString) {
  if (!utcTimeString) return '';

  // The backend may send a naive UTC timestamp ("2026-07-30T20:00:00") OR one
  // that already carries a timezone offset / Z ("2026-07-30T20:00:00+00:00").
  // Only append 'Z' when there is no tz info — appending it to an already
  // offset-carrying string produces an Invalid Date (-> "NaN ... ago").
  const hasTz = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(utcTimeString);
  const updatedOn = new Date(hasTz ? utcTimeString : `${utcTimeString}Z`);
  const ms = updatedOn.getTime();
  if (Number.isNaN(ms)) return '';

  const currentTimestamp = Math.floor(Date.now() / 1000);
  const unixTimestamp = Math.floor(ms / 1000);
  // Clamp small clock-skew (future timestamps) to 0 so it reads "0 seconds ago"
  // instead of falling through to a bogus negative "years ago".
  const timeDifferenceInSeconds = Math.max(0, currentTimestamp - unixTimestamp);

  if (timeDifferenceInSeconds < 60 && timeDifferenceInSeconds >= 0) {
    return `${timeDifferenceInSeconds} ${timeDifferenceInSeconds !== 1 ? 'seconds' : 'second'} ago`;
  } else if (timeDifferenceInSeconds < 3600) {
    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    return `${minutes} ${minutes !== 1 ? 'minutes' : 'minute'} ago`;
  } else if (timeDifferenceInSeconds < 86400) {
    const hours = Math.floor(timeDifferenceInSeconds / 3600);
    return `${hours} ${hours !== 1 ? 'hours' : 'hour'} ago`;
  } else if (timeDifferenceInSeconds < 604800) {
    const days = Math.floor(timeDifferenceInSeconds / 86400);
    return `${days} ${days !== 1 ? 'days' : 'day'} ago`;
  } else if (timeDifferenceInSeconds < 2628000) {
    const weeks = Math.floor(timeDifferenceInSeconds / 604800);
    return `${weeks} ${weeks !== 1 ? 'weeks' : 'week'} ago`;
  } else if (timeDifferenceInSeconds < 31536000) {
    const months = Math.floor(timeDifferenceInSeconds / 2628000);
    return `${months} ${months !== 1 ? 'months' : 'month'} ago`;
  } else {
    const years = Math.floor(timeDifferenceInSeconds / 31536000);
    return `${years} ${years !== 1 ? 'years' : 'year'} ago`;
  }
}
